import { GET_LOADING_LOGIN, GET_USER } from "./action";

const initialState = {
    credential: null,
    loadOn: null,
};
function userReducer(state = initialState, action: { type: any; payload: any; }) {
    switch (action.type) {
        case GET_USER:
            return { ...state, credential: action.payload };
        case GET_LOADING_LOGIN:
            return { ...state, loadOn: action.payload };
        default:
            return state;
    }
}
export default userReducer;
